// src/constants/colors.js
export const SENSOR_COLORS = {
  NORMAL: '#44aa44',    // 정상 - 녹색
  LOW_TEMP: '#4444ff',  // 저온 - 파란색
  HIGH_TEMP: '#ff8800', // 고온 - 주황색
  // ABNORMAL: '#ff4444',  // 이상 - 빨간색
  NO_DATA: '#ccc'       // 데이터없음 - 회색
};

export const STATUS_LABELS = [
  { color: SENSOR_COLORS.NORMAL, label: '정상' },
  { color: SENSOR_COLORS.LOW_TEMP, label: '저온' },
  { color: SENSOR_COLORS.HIGH_TEMP, label: '고온' },
  // { color: SENSOR_COLORS.ABNORMAL, label: '이상 (범위초과)' },
  { color: SENSOR_COLORS.NO_DATA, label: '데이터없음' }
];